<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb__item" [routerLink]="[breadcrumb.link]" detail="false">
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.settings" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>Profile</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="profile --mobile-white">
  <div class="white-wrapper">
    <div class="profile__avatar">
      <img [src]="avatarImagePath" alt="{{ user.name + ' ' + user.lastName }}" class="profile__avatar__image" />
      <span class="profile__avatar__edit" [innerHTML]="'Change photo'"></span>
    </div>
    <div class="profile__form">
      <ion-list class="profile__form__list">
        <div class="profile__form__list__column">
          <ion-item class="profile__form__list__item">
            <ion-label class="label profile__form__list__item__label" position="stacked" [innerHTML]="'Name'"></ion-label>
            <ion-input class="input profile__form__list__item__input" value="Sabine Tesla"></ion-input>
            <ion-icon class="profile__form__list__item__icon --check" name="checkmark-sharp"></ion-icon>
            <span class="profile__form__list__item__info">Changes to your name will be reflected in website or marketing material.</span>
          </ion-item>
          <ion-item class="profile__form__list__item">
            <ion-label class="label profile__form__list__item__label" position="stacked" [innerHTML]="'Email'"></ion-label>
            <ion-input class="input profile__form__list__item__input" value="sabine@gmail.com"></ion-input>
            <ion-icon class="profile__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
          <ion-item class="profile__form__list__item" detail="true">
            <div class="profile__form__list__item__content">
              <span class="profile__form__list__item__content__text" [innerHTML]="'Change password'"></span>
            </div>
          </ion-item>
        </div>
        <div class="profile__form__list__column">
          <ion-item class="profile__form__list__item" detail="true">
            <div class="profile__form__list__item__content">
              <span class="profile__form__list__item__content__text" [innerHTML]="'Qualification'"></span>
              <span class="profile__form__list__item__content__detail" [innerHTML]="'qualification title'"></span>
            </div>
          </ion-item>
          <ion-item class="profile__form__list__item" detail="true">
            <div class="profile__form__list__item__content">
              <span class="profile__form__list__item__content__text" [innerHTML]="'Specialisation'"></span>
              <span
                class="profile__form__list__item__content__detail"
                [innerHTML]="'specialisation, specialisation 2, specialisation 3'"
              ></span>
            </div>
          </ion-item>
          <ion-item class="profile__form__list__item" detail="true">
            <div class="profile__form__list__item__content">
              <span class="profile__form__list__item__content__text" [innerHTML]="'Roles'"></span>
              <span class="profile__form__list__item__content__detail" [innerHTML]="'Owner'"></span>
            </div>
          </ion-item>
        </div>
      </ion-list>
    </div>
    <div class="profile__contact">
      <span class="profile__contact__link" [innerHTML]="'Contact us'"></span>
      <span class="profile__contact__text" [innerHTML]="'to delete your account'"></span>
    </div>
  </div>
</ion-content>
